import { Route } from '@angular/router';
import { ResultComponent } from './result.component';

export const ResultRoutes: Route[] = [
  {
    path: 'result',
    component: ResultComponent
  }
];
